module.exports = __webpack_public_path__ + "img/MGH-Roppongi-12.105ae379.jpg";